<template>
    <div class="flex justify-between items-center bg-white rounded-lg p-4 border border-gray-300">
      <img :src="require(`@/assets/images/pilltypes/${pill.pill.contentType}.svg`)" class="h-12"/>
      <div class="text-azuloscuro text-sm ml-4 leading-5 w-full">
        <div class="text-md">{{pill.pill.contentTitle}}</div>
        <div class="flex-clear flex flex-row justify-between text-gray-600" style="font-size: .65rem">
          <div class="w-2/7 mt-1 text-left">
            <img src="../assets/images/tiempo_de_lectura.svg" class="mr-1 inline-block w-3 h-3" />
            {{pill.pill.estimatedTime}} {{localizedEstimatedTimeUnit}}
          </div>

          <div class="w-2/7 mt-1 text-center">
            <img src="@/assets/images/fecha_de_publicacion.svg" class="mr-1 inline-block w-2 h-2" />
            {{pill.startDate | date}}
          </div>

          <div class="w-2/7 mt-1 text-right">
            <img src="@/assets/images/true.svg" class="mr-1 inline-block w-3 h-3" />
            Realizada
          </div>

          <div class="w-1/7 mt-1 text-right">
            <img v-if="!isInWishlist" src="@/assets/images/heart.svg" class="mr-1 inline-block w-3 h-3" />
            <img v-else src="@/assets/images/Favoritos.svg" class="mr-1 inline-block w-3 h-3" />
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  props: {
    pill: {
      required: true
    },
    isInWishlist: {
      required: false,
      default: false
    }
  },
  filters: {
    date: function(value) {
      return new Date(value).toLocaleDateString("es-ES");
    }
  },
  computed: {
    localizedEstimatedTimeUnit() {
      if (!this.pill  || !this.pill.pill || !this.pill.pill.estimatedTimeUnit) {
        return ''
      }

      const unit = this.pill.pill.estimatedTimeUnit;

      if (unit === 'hours') {
        return 'hrs'
      }

      if (unit === 'minutes') {
        return 'min'
      }

      if (unit === 'seconds') {
        return 'seg'
      }

      return unit
    }
  }
};
</script>
